import { generateUUID } from '@dealstack/frontend/shared/other/react/generateUUID';
import { SecurityParticipationThresholdBasis, SecurityType } from '@dealstack/shared/lib/generated';
import { useFieldArray, UseFormReturn } from 'react-hook-form';
import type { FormSingleSecurity, SecuritiesForm } from './useSecuritiesTableController.types';

export enum SecuritiesFormValues {
	securities = 'securities',
}

export const useSecuritiesTableController = (
	securitiesForm: UseFormReturn<SecuritiesForm, unknown>
) => {
	const {
		fields: securitiesFields,
		append,
		remove,
	} = useFieldArray<SecuritiesForm, SecuritiesFormValues.securities>({
		name: SecuritiesFormValues.securities,

		control: securitiesForm.control,
	});

	const onRemoveSecurityRow = (id: string) => () => {
		const index = securitiesFields.findIndex((item) => item.id === id);
		const field: FormSingleSecurity = securitiesFields[index];
		if (!field) {
			return;
		}
		remove(index);
	};

	const onAddSecurityRow = () => {
		const newSecurityRow: FormSingleSecurity = {
			name: '',
			localId: generateUUID(),
			type: SecurityType.ORDINARY_SHARE,
			isOnEdit: true,
			isOnAdd: true,
			locked: false,
			votesPerUnit: undefined,
			nominalValue: undefined,
			fairMarketValuePerUnit: undefined,
			isSubjectToVesting: false,
			hasTransactions: false,
			residueParticipationThresholdBasis:
				SecurityParticipationThresholdBasis.TOTAL_SOURCES_FOR_ISSUER,
		};
		append(newSecurityRow);
	};

	return { securitiesFields, onAddSecurityRow, onRemoveSecurityRow };
};
